import type { MailboxInfo } from 'owa-client-types';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';
import { getMailboxInfo } from '../selectors/mailRowDataPropertyGetter';
import type TableView from '../store/schema/TableView';
import { isMultiAccountTable } from './isMultiAccountTable';

export function getRowKeyMailboxInfoIfUnifiedInboxOrMultiAccountSearch(
    mailboxInfo: MailboxInfo,
    tableView: TableView,
    rowKey: string
): MailboxInfo {
    if (isUnifiedInboxMailboxInfo(mailboxInfo) || isMultiAccountTable(tableView)) {
        return getMailboxInfo(rowKey, tableView) ?? mailboxInfo;
    }

    return mailboxInfo;
}
